import { jsx as t } from "react/jsx-runtime";
import { tv as r } from "tailwind-variants";
import m from "./Flags.js";
import d from "./Image.js";
import i from "./Header.js";
const n = r({
  base: ["p-5", "w-full"]
}), c = ({ children: a, className: s }) => /* @__PURE__ */ t("div", { className: n({ class: s }), children: a }), f = r({
  base: [
    "bg-white",
    "border",
    "border-neutral-200",
    "isolate",
    "relative",
    "rounded-2xl",
    "w-full"
  ]
}), e = ({ className: a, children: s, tagName: o = "div", ...l }) => /* @__PURE__ */ t(o, { className: f({ class: a }), ...l, children: s });
e.Content = c;
e.Flags = m;
e.Header = i;
e.Image = d;
export {
  e as default
};
